import useQuery from '../useQuery';

/** M17 (#293, Plan 2 Slice 1): the org's integration connections (eBay + future
 * channel accounts). Read-only public shape — never carries token fields. Any
 * member can read. Mirrors `useChannelsQuery` (same wrapper + shape). */
function useIntegrationsQuery(sellerId, params) {
  return useQuery(`/integrations/${sellerId}/connections/`, {
    enabled: Boolean(sellerId),
    staleTime: 60 * 1000,
    ...params,
  });
}

export default useIntegrationsQuery;
